export default "__VITE_ASSET__DuCzojYM__"